import { render, staticRenderFns } from "./applyRecord.vue?vue&type=template&id=36051b3d"
import script from "./applyRecord.vue?vue&type=script&lang=js"
export * from "./applyRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports